export const types = ({ types }) => types
export const processors = ({ processors }) => processors
export const customFields = ({ customFields }) => customFields
export const addressFound = ({ addressFound }) => addressFound
export const paymentMethods = ({ paymentMethods }) => paymentMethods
export const billingSetting = ({ billingSettings }) => billingSettings
export const webhookSetting = ({ webhookSettings }) => webhookSettings
export const paymentMethod = ({ paymentMethod }) => paymentMethod
export const cardMethod = ({ cardMethod }) => cardMethod
export const transferMethod = ({ transferMethod }) => transferMethod
export const balanceMethod = ({ balanceMethod }) => balanceMethod
export const customFieldsValues = ({ customFieldsValues }) => customFieldsValues
export const gatewayFieldsValues = ({ gatewayFieldsValues }) => gatewayFieldsValues
export const billetMethod = ({ billetMethod }) => billetMethod
export const reprocessBilletMethod = ({ reprocessBilletMethod }) => reprocessBilletMethod
export const reprocessCardMethod = ({ reprocessCardMethod }) => reprocessCardMethod
export const yapayToken = ({ yapayToken }) => yapayToken



// WEBPACK FOOTER //
// ./src/app/pages/settings/vuex/getters.js